module.exports = __webpack_public_path__ + "static/media/commercial-service-network.0e32f1ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/commercial-service-network.svg
// module id = 2538
// module chunks = 2